const hintParameterNamesMap = /** @type {Record<keyof UADataValues, string>} */ ({
  model: 'ch_m',
  brands: 'ch_b',
  platform: 'ch_p',
  platformVersion: 'ch_pv',
  fullVersionList: 'ch_fvl',
});

export const hintNames = Object.keys(hintParameterNamesMap);

/**
 * Converts a hint to a string and encodes it
 *
 * @param {UADataValues[keyof UADataValues]} hint
 * @returns {string}
 */
const convertHintValue = (hint) => {
  if (!hint) {
    return '';
  }

  const hintValue = typeof hint === 'object' ? JSON.stringify(hint) : hint;

  return window.encodeURIComponent(hintValue);
};

/**
 * Converts a hints object into a flat URL query string.
 *
 * @param {UADataValues} hints
 * @returns {string}
 */
export const convertHintsToFlatUrlStructure = (hints) => {
  if (typeof hints !== 'object') {
    return '';
  }

  let result = '';

  for (const hintKey in hints) {
    const hintParameterName = hintParameterNamesMap[/** @type {keyof UADataValues} */ (hintKey)];
    const hintParameterValue = hints[/** @type {keyof UADataValues} */ (hintKey)];

    if (hintParameterName && hintParameterValue) {
      result += `&${hintParameterName}=${convertHintValue(hintParameterValue)}`;
    }
  }

  return result;
};
